import Vue from "vue";
import { ref, get, query, onChildAdded, onChildChanged, onChildRemoved } from "firebase/database";

import { database } from "@/common/firebase";
import { createSyncLegifrance, continueSyncLegifrance, cleanResourcesLegifrance } from "@/common/functions";

import { ObjectToSortedArray, createModuleResetter } from "@/helpers/utils";

import { FETCH, CREATE, CONTINUE, LISTEN, CLEAN } from "../../actions";
import { SET_KEY, SET_ITEM, DEL_ITEM, RESET_STORE } from "../../mutations";

const getInitState = () => ({
  items: {},
});

const getters = {
  itemsSorted: (state) => {
    return ObjectToSortedArray(state.items, "createdAt");
  },
};

const mutations = {
  [SET_KEY](state, { key, value }) {
    Vue.set(state, key, value);
  },
  [SET_ITEM](state, { id, ...payload }) {
    Vue.set(state.items, id, { ...payload });
  },
  [DEL_ITEM](state, { id }) {
    Vue.delete(state.items, id);
  },
  [RESET_STORE]: createModuleResetter(getInitState),
};

const actions = {
  async [FETCH]({ commit }) {
    try {
      const syncsRef = ref(database, `index/syncs`);
      const syncs = await get(syncsRef).then((snapshot) => snapshot.val());

      if (syncs) {
        Object.entries(syncs).forEach(([id, syncData]) => {
          commit(SET_ITEM, { id, ...syncData });
        });
      }

      return { isSuccess: true };
    } catch (error) {
      console.error("Error fetching syncs:", error);
      return { isSuccess: false, error };
    }
  },

  async [CREATE]() {
    try {
      await createSyncLegifrance();
      return { isSuccess: true };
    } catch (errorData) {
      console.error("Error syncing dataset:", errorData);
      return { isSuccess: false, error: errorData };
    }
  },
  async [CONTINUE](_, payload) {
    try {
      await continueSyncLegifrance(payload);
      return { isSuccess: true };
    } catch (errorData) {
      console.error("Error syncing dataset:", errorData);
      return { isSuccess: false, error: errorData };
    }
  },
  async [CLEAN](_, payload) {
    try {
      await cleanResourcesLegifrance(payload);
      return { isSuccess: true };
    } catch (errorData) {
      console.error("Error syncing dataset:", errorData);
      return { isSuccess: false, error: errorData };
    }
  },

  async [LISTEN]({ commit }) {
    const syncsRef = query(ref(database, `index/syncs`));

    onChildAdded(syncsRef, (snapshot) => {
      commit(SET_ITEM, { id: snapshot.key, ...snapshot.val() });
    });

    onChildChanged(syncsRef, (snapshot) => {
      commit(SET_ITEM, { id: snapshot.key, ...snapshot.val() });
    });

    onChildRemoved(syncsRef, (snapshot) => {
      commit(DEL_ITEM, { id: snapshot.key });
    });
  },
};

export default {
  namespaced: true,
  state: getInitState(),
  getters,
  mutations,
  actions,
};
